import { IPagination, IResponse, IResponseWithPagination } from 'interfaces/common';
import { IResourcesItem } from 'interfaces/resources.interface';
import appService from 'services/common';

const getOnboardingResources = (params?: IPagination) => {
  return appService.get<IResponse<IResponseWithPagination<IResourcesItem>>>('/onboarding-resources-manage', { params });
};

export { getOnboardingResources };
